var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29372",
    "data-name": "Group 29372",
    transform: "translate(-229.918 -103.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(229.918 103.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_16_",
    "data-name": "svgexport-17 (16)",
    transform: "translate(243.913 108.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49701",
    "data-name": "Path 49701",
    d: "M25.673,24.022,20.5,17.395l-6.677-5.221a.185.185,0,0,0-.251.251l5.221,6.627,6.627,5.171A.161.161,0,0,0,25.673,24.022Z",
    transform: "translate(-6.496 -5.749)",
    fill: "#44baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49702",
    "data-name": "Path 49702",
    d: "M25.472,12.174l-6.627,5.221-5.171,6.627a.185.185,0,0,0,.251.251L20.551,19.1l5.171-6.627C25.823,12.274,25.622,12.073,25.472,12.174Z",
    transform: "translate(-6.546 -5.75)",
    fill: "#44baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49703",
    "data-name": "Path 49703",
    d: "M23.361,6.088a.157.157,0,0,0-.3,0L20.7,15.175l2.36,9.087a.157.157,0,0,0,.3,0l2.36-9.087Z",
    transform: "translate(-10.058 -2.676)",
    fill: "#eb2a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49704",
    "data-name": "Path 49704",
    d: "M25.663,21.56,16.575,19.2,7.488,21.56a.157.157,0,0,0,0,.3l9.087,2.36,9.087-2.36C25.813,21.861,25.813,21.61,25.663,21.56Z",
    transform: "translate(-3.423 -9.262)",
    fill: "#eb2a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 1.356,
    cy: 1.356,
    r: 1.356,
    transform: "translate(11.796 11.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28849",
    "data-name": "Group 28849",
    transform: "translate(0.5 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49705",
    "data-name": "Path 49705",
    d: "M13.654.6h.5V2.809h-.5L12.6,1.454V2.809h-.5V.6h.452L13.6,2.006V.6ZM24.549,11.394v.452h-1.1V12.3h1v.4h-1v.452h1.1V13.6H22.942V11.394ZM1.454,12.65l.4-1.255h.5l.4,1.255.452-1.255h.552L3.01,13.6h-.4l-.5-1.506L1.6,13.6H1.253L.5,11.394h.552Zm11.5,10.192a.184.184,0,0,0-.05.151c0,.05.05.1.1.151a1.1,1.1,0,0,0,.4.151,1.57,1.57,0,0,1,.5.251.614.614,0,0,1,.151.452.645.645,0,0,1-.2.5,1.077,1.077,0,0,1-.6.2,1.469,1.469,0,0,1-.954-.4l.3-.351a1.08,1.08,0,0,0,.653.3c.1,0,.151,0,.2-.05s.1-.1.1-.151-.05-.1-.1-.151a.424.424,0,0,0-.3-.1,1.133,1.133,0,0,1-.552-.251.636.636,0,0,1-.2-.452.645.645,0,0,1,.2-.5,1.012,1.012,0,0,1,.552-.151,1.39,1.39,0,0,1,.452.05,1.5,1.5,0,0,1,.4.2l-.251.351a.965.965,0,0,0-.6-.2c-.1-.05-.151-.05-.2,0Z",
    transform: "translate(-0.5 -0.6)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassHighlighted);
export default __webpack_public_path__ + "static/media/compassHighlighted.2cf198a1832a9281df93a8b43cc24874.svg";
export { ForwardRef as ReactComponent };